module.exports = __webpack_public_path__ + "static/img/07.2e46cb0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/mobile/07.png
// module id = 2jVy
// module chunks = 1